import Vue from 'vue';
import VueRouter from 'vue-router';

import { store } from '@/store/store';
import Login from '@/views/Login.vue';
import Logout from '@/views/Logout.vue';
import ResetPassword from '@/views/ResetPassword';
import Signup from '@/views/Signup.vue';
import Protected from '@/views/Protected';

import NotFound from '@/views/NotFound';

Vue.use(VueRouter);

const routes = [
  { path: '/', component: Login },
  { path: '/login', name: 'login', component: Login, alias: ['/log-in', '/signin', '/sign-in'] },
  { path: '/logout', name: 'logout', component: Logout },
  { path: '/reset-password/:token', name: 'reset-password', component: ResetPassword },
  { path: '/signup', name: 'signup', component: Signup },
  {
    path: '/protected',
    name: 'protected',
    component: Protected,
    meta: { requiresAuth: true }
  },
  { path: '*', name: 'notfound', component: NotFound }
];

const router = new VueRouter({
  routes,
  //mode: 'history' //to remove # in url
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(route => route.meta.requiresAuth)) {
    if (store.getters.isAuthenticated) {
      next();
      return;
    }
    next('/login');
  } else {
    next();
  }
});

export { router };